<template>
  <el-dialog
    :close-on-click-modal="false"
    destroy-on-close
    append-to-body
    :visible="true"
    width="820px"
    @close="$emit('close')"
  >
    <template #title>
      <div
        style="
          display: flex;
          align-items: center;
          justify-content: space-between;
        "
      >
        <strong style="font-size: 16px; margin-right: 10px; color: #42444d"
          >Thêm lịch hẹn mới</strong
        >
      </div>
    </template>
    <div
      class="pt-3 px-2"
      style="box-shadow: rgba(17, 12, 46, 0.15) 0px 48px 100px 0px"
    >
      <div class="container px-0">
        <div class="row">
          <div class="col-6 mb-2">
            <div class="d-flex">
              <div
                class="required d-flex align-items-center"
                style="width: 120px"
              >
                Khách hàng
              </div>
              <el-select
                v-model="searchKey"
                filterable
                remote
                placeholder="Tìm kiếm liên hệ"
                :remote-method="searchContacts"
                style="width: 100%"
                @change="handleSelectChange"
              >
                <el-option
                  v-for="item in list"
                  :key="item.index"
                  :label="`${item.displayName} (${item.phone}) `"
                  :value="item.id"
                />
                <infinite-loading @infinite="infiniteHandler" />
              </el-select>
            </div>
            <div
              class="mt-2 w-100 align-items-center"
              style="
                height: 32.5px;
                border: 1px solid #dcdfe6;
                border-radius: 4px;
                display: flex;
                align-items: center;
                padding-left: 4px;
              "
            >
              <template>
                <div
                  v-if="selectedValue"
                  type="info"
                  class="d-flex selected-tag"
                >
                  <div class="ms-2">{{ selectedValue }}</div>
                  <button @click="handleRemove" class="btn-remove-group">
                    <IconFont name="icon-close" />
                  </button>
                </div>
                <span
                  v-else
                  style="font-size: 13px; margin-left: 10px; color: #c0c4cc"
                  >Khách hàng đã chọn</span
                >
              </template>
            </div>
          </div>
          <div class="col-6 mb-2 d-flex flex-column justify-content-between">
            <ValidationObserver ref="obs">
              <div class="required">Người tham gia</div>
              <ValidationProvider
                name="Người tham gia"
                rules="required-select: người tham gia"
                v-slot="{ errors }"
                mode="lazy"
              >
                <el-select
                  v-model="formData.participants"
                  style="width: 100%; margin-top: 19px"
                  placeholder="Tìm nhân viên"
                  multiple
                  collapse-tags
                  filterable
                >
                  <el-option
                    v-for="option in app.employeeList"
                    :key="option.id"
                    :label="option.username"
                    :value="option.username"
                  />
                </el-select>
                <div v-if="errors[0]" class="mt-1 ms-1">
                  <InputError :message="errors[0]" />
                </div>
              </ValidationProvider>
            </ValidationObserver>
          </div>
          <div class="col-12 mb-2">
            <ValidationObserver ref="obs">
              <div class="required">Tên lịch hẹn</div>
              <ValidationProvider
                name="Tên lịch hẹn"
                rules="required-input: tên lịch hẹn"
                v-slot="{ errors }"
              >
                <el-input
                  v-model="formData.name"
                  style="width: 100%"
                  type="text"
                  class="mt-1"
                  placeholder="Nhập lịch hẹn"
                  maxlength="250"
                />
                <div v-if="errors[0]" class="mt-1 ms-1">
                  <InputError :message="errors[0]" />
                </div>
              </ValidationProvider>
            </ValidationObserver>
          </div>
          <div class="col-4 mb-2">
            <div class="required">Ngày</div>
            <el-date-picker
              style="width: 100%"
              class="mt-1"
              placeholder="Chọn ngày"
              v-model="formData.time"
              format="dd/MM/yyyy"
            />
          </div>
          <div class="col-4 mb-2">
            <div class="required">Thời gian</div>
            <!-- <el-time-picker
              style="width: 100%"
              is-range
              class="mt-1"
              format="HH:mm"
              start-placeholder="Từ"
              end-placeholder="Đến"
              v-model="formData.timeStart"
            /> -->
            <div class="d-flex">
              <el-time-picker
                v-model="formData.timeStart"
                placeholder="Từ"
                format="HH:mm"
                class="mt-1"
              />
              <el-time-picker
                v-model="formData.timeEnd"
                placeholder="Đến"
                format="HH:mm"
                class="mt-1 ms-1"
              />
            </div>
          </div>
          <div class="col-4 mb-2">
            <div>Nhắc hẹn trước</div>
            <div class="d-flex justify-content-between">
              <el-input-number
                controls-position="right"
                class="mt-1"
                style="width: 100%"
                v-model="formData.timeNotify"
              />
              <el-select
                v-model="formData.timeNotifyUnit"
                style="max-width: 90px"
                class="mt-1 ms-1"
                placeholder="Chọn"
              >
                <el-option
                  v-for="(option, index) in options"
                  :key="index"
                  :label="option.name"
                  :value="option.value"
                />
              </el-select>
            </div>
          </div>
          <el-input
            type="textarea"
            :autosize="{ minRows: 2, maxRows: 5 }"
            class="mt-1 me-3"
            placeholder="Thêm ghi chú"
            v-model="formData.note"
          />
          <span
            slot="footer"
            class="dialog-footer py-2 d-flex justify-content-end"
          >
            <el-button size="small" class="mt-1" @click="$emit('close')"
              >Hủy</el-button
            >
            <el-button
              size="small"
              class="mt-1"
              type="primary"
              @click="submit"
              :disabled="
                !formData.participants.length ||
                !formData.name.trim() ||
                !formData.time ||
                !formData.timeStart ||
                !formData.timeEnd ||
                !formData.timeNotifyUnit ||
                !selectedValue.length
              "
              >Tạo lịch hẹn</el-button
            >
          </span>
        </div>
      </div>
    </div>
  </el-dialog>
</template>
<script>
import { HTTP } from "@/lib/http-common";
import InfiniteLoading from "vue-infinite-loading";
export default {
  components: {
    InfiniteLoading,
  },
  data() {
    return {
      status: [],
      contactName: "",
      contactPhone: "",
      searchKey: "",
      value: [],
      showInfinite: false,
      page: 0,
      pageSize: 10,
      list: [],
      selectedValue: "",
      formData: {
        contactId: "",
        name: "",
        note: "",
        participants: "",
        time: "",
        timeStart: "",
        timeEnd: "",
        timeNotify: 30,
        timeNotifyUnit: "MINUTE",
        // status: "NOT_START",
      },
      statuses: [
        { value: "NOT_START", label: "Chưa bắt đầu" },
        { value: "INPROCESS", label: "Đang tiến hành" },
        { value: "DONE", label: "Hoàn thành" },
        { value: "OVERTIME", label: "Quá hạn" },
        { value: "CANCEL", label: "Đã hủy" },
      ],
      isSearching: false,
      hasMore: true,
      options: [
        { name: "Phút", value: "MINUTE" },
        { name: "Giờ", value: "HOUR" },
        { name: "Ngày", value: "DAY" },
        { name: "Tháng", value: "MONTH" },
      ],
    };
  },
  created() {
    if (this.app.user.type === "ADMIN") {
      this.formData.participants = "";
    } else {
      this.formData.participants = [this.app.user.swUsername];
    }
  },
  methods: {
    handleRemove() {
      this.selectedValue = "";
    },
    async searchContacts(query) {
      this.page = 0;
      this.isSearching = true;
      this.searchKey = query;

      try {
        const payload = {
          searchKey: query,
          employeeId: `${this.app.user.id}_${this.app.user.swUsername}`,
          page: this.page,
          pageSize: this.pageSize,
        };
        const response = await HTTP.post(
          "/api/appointment/search-contact",
          payload
        );
        if (this.app.user.type === "ADMIN") {
          this.list = response.data.content;
        } else {
          this.list = response.data;
        }
        this.hasMore = response.data.content.length === this.pageSize;
      } catch (error) {
        console.error("Lỗi tìm kiếm:", error);
      } finally {
        this.isSearching = false;
      }
    },
    async infiniteHandler($state) {
      if (this.isSearching || !this.hasMore) {
        $state.complete();
        return;
      }

      try {
        const payload = {
          searchKey: this.searchKey,
          employeeId: `${this.app.user.id}_${this.app.user.swUsername}`,
          page: this.page + 1,
          pageSize: this.pageSize,
        };
        const response = await HTTP.post(
          "/api/appointment/search-contact",
          payload
        );
        let newData;
        if (this.app.user.type === "ADMIN") {
          newData = response.data.content;
        } else {
          newData = response.data;
        }

        if (newData.length) {
          this.list.push(...newData);
          this.page += 1;
          $state.loaded();
        } else {
          this.hasMore = false;
          $state.complete();
        }
      } catch (error) {
        console.error("Lỗi tải thêm:", error);
        $state.complete();
      }
    },
    calculateTsNotify(fromTime, timeNotify, timeNotifyUnit) {
      const time = timeNotify;
      let offset = 0;
      switch (timeNotifyUnit) {
        case "MINUTE":
          offset = time * 60 * 1000;
          break;
        case "HOUR":
          offset = time * 60 * 60 * 1000;
          break;
        case "DAY":
          offset = time * 24 * 60 * 60 * 1000;
          break;
        case "MONTH":
          offset = time * 24 * 60 * 60 * 1000 * 30;
          break;
      }

      return fromTime - offset;
    },
    handleSelectChange(value) {
      const selectedContact = this.list.find((item) => item.id === value);

      this.contactName = selectedContact.displayName;
      this.contactPhone = selectedContact.phone;
      this.searchKey = "";
      this.selectedValue = `${this.contactName} (${this.contactPhone})`;
    },
    combineDateAndTime(datePart, timePart) {
      const combined = new Date(datePart);
      combined.setHours(
        timePart.getHours(),
        timePart.getMinutes(),
        timePart.getSeconds(),
        timePart.getMilliseconds()
      );
      return combined.getTime();
    },
    async handleCreate(payload) {
      const res = await HTTP.post("/api/appointment/create", payload);
      if (res.status === "success") {
        this.alert("success", "Thêm lịch hẹn thành công");
        this.$emit("createAppointment", res.data);
        this.$emit("close");
      } else {
        this.$message.error("Không thể tạo lịch hẹn");
      }
    },
    updateAppointmentStatuses(response) {
      const now = new Date();
      const currentMinute = Math.floor(now.getTime() / (60 * 1000));
      response.forEach((appt) => {
        const startMinute = Math.floor(appt.timeStart / (60 * 1000));
        const endMinute = Math.floor(appt.timeEnd / (60 * 1000));
        let newStatus = appt.status;
        if (
          appt.status === "NOT_START" &&
          currentMinute >= startMinute &&
          currentMinute < endMinute
        ) {
          newStatus = "INPROCESS";
        }
        if (
          !["DONE", "CANCEL", "OVERTIME"].includes(appt.status) &&
          currentMinute >= endMinute
        ) {
          newStatus = "OVERTIME";
        }
        this.status.push(newStatus);
      });
    },

    async submit() {
      try {
        const selectedContact = this.list.find(
          (item) => item.displayName === this.contactName
        );
        const fromTime = this.combineDateAndTime(
          this.formData.time,
          this.formData.timeStart
        );
        const toTime = this.combineDateAndTime(
          this.formData.time,
          this.formData.timeEnd
        );
        if (fromTime + 60000 > toTime) {
          this.$message.error(
            "Thời gian bắt đầu phải nhỏ hơn thời gian kết thúc."
          );
          return;
        } else {
          const tsNotify = this.calculateTsNotify(
            fromTime,
            this.formData.timeNotify,
            this.formData.timeNotifyUnit
          );
          const data = {
            contactId: selectedContact.id,
            timeStart: fromTime,
            timeEnd: toTime,
          };
          const payload = {
            contactId: selectedContact.id,
            contactName: this.contactName,
            contactPhone: this.contactPhone,
            name: this.formData.name.trim(),
            note: this.formData.note.trim(),
            participants: JSON.stringify(this.formData.participants),
            timeStart: fromTime,
            timeEnd: toTime,
            timeNotify: this.formData.timeNotify,
            timeNotifyUnit: this.formData.timeNotifyUnit,
            tsNotify: tsNotify,
          };

          const response = await HTTP.post(
            "/api/appointment/check-duplicate",
            data
          );
          this.updateAppointmentStatuses(response.data);
          if (
            response.data.length > 0 &&
            this.status.filter((s) =>
              ["NOT_START", "INPROCESS", "OVERTIME"].includes(s)
            ).length > 0
          ) {
            try {
              await this.$confirm(
                `Lịch hẹn với khách hàng ${this.contactName} đã tồn tại trên hệ thống.
           Bạn có muốn tiếp tục không?`,
                "Xác nhận dữ liệu trùng",
                {
                  confirmButtonText: "Tiếp tục",
                  cancelButtonText: "Hủy",
                  type: "warning",
                  dangerouslyUseHTMLString: true,
                }
              );
              await this.handleCreate(payload);
            } catch (ex) {
              console.log("User cancelled confirmation", ex);
            }
          } else {
            await this.handleCreate(payload);
          }
        }
      } catch (error) {
        this.$message.error("Đã xảy ra lỗi, vui lòng thử lại.");
      }
    },
  },
};
</script>
<style scoped>
.btn-remove-group {
  background-color: transparent;
  border: none;
  cursor: pointer;
  align-items: center;
}
.selected-tag {
  display: inline-flex;
  align-items: center;
  height: 20px;
  border-radius: 4px;
  background-color: #f0f2f5;
  border: 1px solid #dcdfe6;
  font-size: 13px;
  color: #303133;
}
</style>
